import { render } from "./Sms-tab.vue?vue&type=template&id=6e01d5bf&scoped=true"
import script from "./Sms-tab.vue?vue&type=script&lang=js"
export * from "./Sms-tab.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=6e01d5bf&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e01d5bf"]])

export default __exports__